"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SttBox = _interopRequireDefault(require("../../SttLayout/SttBox"));
var _Notification = _interopRequireDefault(require("./Notification"));
var _styles = require("@material-ui/core/styles");
var _reactDraggable = _interopRequireDefault(require("react-draggable"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    menuUsuario: {
      right: 10
    },
    boxMenuUsuario: {
      position: 'fixed',
      display: 'flex',
      padding: 0,
      spacing: 0,
      border: '1px solid #d3d4d5',
      boxShadow: '4px 4px 4px 2px rgba(158,158,158,0.8)',
      right: 20,
      bottom: 20,
      zIndex: 1000,
      borderRadius: theme.spacing(0.5)
    }
  };
});
var MenuUsuario = function MenuUsuario(_ref) {
  var notifications = _ref.notifications,
    setIdWebconferenciaSelecionada = _ref.setIdWebconferenciaSelecionada,
    setTituloWebconferencia = _ref.setTituloWebconferencia,
    setItemBiblioteca = _ref.setItemBiblioteca,
    _ref$startExpanded = _ref.startExpanded,
    startExpanded = _ref$startExpanded === void 0 ? true : _ref$startExpanded,
    customClassName = _ref.customClassName;
  var classes = useStyles();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    notificationOpen = _useState2[0],
    setNotificationOpen = _useState2[1];
  (0, _react.useEffect)(function () {
    setNotificationOpen(notifications && notifications.length > 0);
  }, [notifications]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, notificationOpen && /*#__PURE__*/_react["default"].createElement(_reactDraggable["default"], {
    cancel: ".notDragabble",
    bounds: "html"
  }, /*#__PURE__*/_react["default"].createElement(_SttBox["default"], {
    className: [classes.boxMenuUsuario, customClassName]
  }, /*#__PURE__*/_react["default"].createElement(_Notification["default"], {
    notifications: notifications,
    setIdWebconferenciaSelecionada: setIdWebconferenciaSelecionada,
    setTituloWebconferencia: setTituloWebconferencia,
    setItemBiblioteca: setItemBiblioteca,
    startExpanded: startExpanded
  }))));
};
var _default = MenuUsuario;
exports["default"] = _default;